import APP from './model/APP/controller/APP.js';
import { CONFIG } from './model/APP/config/CONFIG.js';
import PAGE, { page } from './model/APP/page/PAGE.js';
import BODY, { body } from './model/DOM/body/BODY.js';
/** Initializes the Application */
document.addEventListener('DOMContentLoaded', function () {
    //mermaid.startOnLoad = false;
    //mermaid.initialize({startOnLoad: false})
    let main = new PAGE(new BODY(body('spoon-ui')), page('1', CONFIG));
    const app = new APP(main, CONFIG);
    app.launch();
});
